import GraphQLInterfaceV1 from './GraphQLInterfaceV1';
import { GraphQLInterfaceV1Type } from '@clientos/types';

export { createNoopGraphQLInterface } from './NoopInterface';

let graphQLInterfaceV1: GraphQLInterfaceV1;

export default async function initializeGraphQLInterfaceV1(): Promise<GraphQLInterfaceV1Type> {
  if (graphQLInterfaceV1) return graphQLInterfaceV1.getInterface();
  graphQLInterfaceV1 = new GraphQLInterfaceV1();
  return graphQLInterfaceV1.getInterface();
}
